import React, { useEffect, useState } from 'react';
import { MessageCircle, Phone } from 'lucide-react';

export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Animation slide-in au chargement
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const WHATSAPP_LINK = "https://wa.me/33640486009?text=Bonjour%2C%20je%20souhaite%20prendre%20rendez-vous%20%F0%9F%92%85";

  return (
    <>
      {/* Bouton Appeler flottant - Mobile uniquement */}
      <a
        href="tel:+33640486009"
        className="fixed bottom-24 right-4 z-[999] w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all md:hidden"
        style={{ borderWidth: '2px', borderColor: '#E8B4D1' }}
        aria-label="Appeler"
      >
        <Phone size={24} style={{ color: '#D1477A' }} />
      </a>

      {/* Bouton WhatsApp sticky - MOBILE UNIQUEMENT */}
      <div 
        className={`fixed bottom-0 left-0 right-0 z-[1000] md:hidden transition-transform duration-500 ease-out ${
          isVisible ? 'translate-y-0' : 'translate-y-full'
        }`}
        style={{
          paddingBottom: 'max(16px, env(safe-area-inset-bottom))'
        }}
      >
        <div className="px-3 pt-3 bg-gradient-to-t from-white via-white/95 to-transparent">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full py-4 rounded-2xl text-white font-bold text-lg shadow-xl active:scale-[0.98] transition-transform"
            style={{ backgroundColor: '#25D366' }}
          >
            <MessageCircle size={24} />
            Réserver sur WhatsApp
          </a>
        </div>
      </div>

      {/* Desktop: Bouton flottant discret - DESKTOP UNIQUEMENT */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:flex fixed bottom-6 right-6 z-[1000] items-center gap-3 px-6 py-4 rounded-full text-white font-semibold shadow-xl hover:shadow-2xl transition-all hover:scale-105"
        style={{ backgroundColor: '#25D366' }}
      >
        <MessageCircle size={22} />
        WhatsApp
      </a>
    </>
  );
};
